module.exports = __webpack_public_path__ + "img/notebook.3ae233a4.png";